import React from "react";
import "./Learning.css";

const courses = [
  {
    icon: "🎓",
    number: "01",
    title: "CPC Course",
    desc: "Certified Professional Coder training — master outpatient coding, anatomy, and payer guidelines with AAPC-aligned curriculum.",
    tag: "AAPC · Outpatient",
  },
  {
    icon: "📚",
    number: "02",
    title: "CCS Course",
    desc: "Certified Coding Specialist program focused on inpatient hospital coding using ICD-10-CM/PCS and AHIMA standards.",
    tag: "AHIMA · Inpatient",
  },
  {
    icon: "⚙️",
    number: "03",
    title: "CRC Course",
    desc: "Certified Risk Adjustment Coder program covering HCC coding, risk models, and compliance for value-based care.",
    tag: "HCC · Risk Adjustment",
  },
  {
    icon: "🔬",
    number: "04",
    title: "Advanced Coding & Training",
    desc: "Deep-dive training on complex coding scenarios, multi-system cases, auditing techniques, and productivity enhancement.",
    tag: "Advanced · Audit",
  },
  {
    icon: "❤️",
    number: "05",
    title: "Specialty Coding Programs",
    desc: "Focused tracks in Cardiology, Radiology, Surgery and more — learn the nuances of specialty-specific CPT and ICD coding.",
    tag: "Cardiology · Surgery · Radiology",
  },
  {
    icon: "💼",
    number: "06",
    title: "Medical Billing Essentials",
    desc: "Comprehensive billing fundamentals covering claims submission, denial management, ERA/EOB reading, and payer follow-up.",
    tag: "Billing · Claims",
  },
];

const Learning = () => {
  return (
    <div className="Services_pg_wrap">

      {/* Header */}
      <div className="Services_pg_header">
        <span className="Services_pg_pill">Certification Programs</span>
        <h2 className="Services_pg_heading">
          Our <em className="Services_pg_heading_em">Courses</em>
        </h2>
        <p className="Services_pg_sub">
          Certified Medical Coding &amp; Billing courses designed to launch and advance your healthcare career.
        </p>
      </div>

      {/* 3×2 Cards grid */}
      <div className="Services_pg_grid">
        {courses.map((c, i) => (
          <div
            key={i}
            className="Services_pg_card"
            style={{ animationDelay: `${i * 0.08}s` }}
          >
            <span className="Services_pg_card_num">{c.number}</span>
            <div className="Services_pg_card_icon">{c.icon}</div>
            <h3 className="Services_pg_card_title">{c.title}</h3>
            <p className="Services_pg_card_desc">{c.desc}</p>
            <span className="Services_pg_card_tag">{c.tag}</span>
          </div>
        ))}
      </div>

    </div>
  );
};

export default Learning;